import { FC, Suspense } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

import { ProfileHeader } from './components';
import BravoContent from '../BravoContent';
import { Spinner } from '../../spinner';

const ProfileLayout: FC = () => {
  return (
    <Layout>
      <ProfileHeader />
      <Suspense
        fallback={
          <BravoContent>
            <Spinner />
          </BravoContent>
        }
      >
        <Layout.Content>
          <Outlet />
        </Layout.Content>
      </Suspense>
    </Layout>
  );
};

export default ProfileLayout;
